<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="toch">CONTENTS</p>
<p class="toc"><a href="#/chap01">Chapter One</a></p>
<p class="toc"><a href="#/chap02">Chapter Two</a></p>
<p class="toc"><span href="#/chap03" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc"><span href="#/chap04" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc"><span href="#/chap05" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc"><span href="#/chap06" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc"><span href="#/chap07" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc"><span href="#/chap08" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc"><span href="#/chap09" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="toc"><span href="#/chap10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="toc"><span href="#/chap11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="toc"><span href="#/chap12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="toc"><span href="#/chap13" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="toc"><span href="#/chap14" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="toc"><span href="#/chap15" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="toc"><span href="#/chap16" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="toc"><span href="#/chap17" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="toc"><span href="#/chap18" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="toc"><span href="#/chap19" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="toc"><span href="#/chap20" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="toc"><span href="#/chap21" title="Link target outside of Sample">Chapter Twenty-One</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4e0b426c